module.exports = __webpack_public_path__ + "img/thumb-invision-support@2x.f31e2137.png";